import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const transactionApi = apiResourceBuilder({
  name: 'pmts/transactions',
  idResolver: ({ key }) => key,
});

export const TransactionSchema = new schema.Entity(
  'transactions',
  {},
  { idAttribute: 'key' }
);
export default entityActionCreator({
  schema: TransactionSchema,
  api: transactionApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/transactions/index.js